const loadingLabel = "Carregando";
const ptBR = {
  loadingLabel
};
export {
  ptBR as default,
  loadingLabel
};
